import Vue from 'vue'
import Vuex from 'vuex'
import {version} from '../package.json';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    version: version,
    searchParams:{
      makeIdProxy: null,
      modelIdProxy: null,
      bodyTypeEnumProxy: null,
      fuelEnumProxy: null,
      gearingEnumProxy: null,
      emissionClassEnumProxy: null,
      powerFromIntProxy: null,
      powerToIntProxy: null,
      firstRegistrationFromIntProxy: null,
      firstRegistrationToIntProxy: null,
      mileageFromIntProxy: null,
      mileageToIntProxy: null,
      priceFromIntProxy: null,
      priceToIntProxy: null,
      offerTypeEnumProxy: [],
      bodyColorEnumProxy: null,
      upholsteryEnumProxy: null,
      equipmentEnumProxy: [],
      sortObjectProxy: {
        id:'5-1',
        sortBy: 'Age',
        sortOrder: 'Asc'
      },
      pageIntProxy: 1
    },
    sortChanged: false,
    siteUrl: '',
    carOfTheWeekId: '',
    marketPath: '',
    detailsPath: '',
    selectedId: '',
    phoneLocationVW: '',
    phoneLocationSEAT: '',
    phoneLocationFCA: '',
    phoneAutoCRMLead: '',
    resultsCountProxy: ''
  },
  mutations: {
    initialiseStore(state) {
      // Check if the ID exists
      if(localStorage.getItem('autoscoutstore')) {
        let store = JSON.parse(localStorage.getItem('autoscoutstore'));

        // Check the version stored against current. If different, don't
        // load the cached version
        // alert(version);
        if(store.version == version) {
          this.replaceState(
              Object.assign(state, store)
          );
        } else {
          state.version = version;
        }
      }
    },
    updateSearchParams(state, value){
      state.searchParams = {...state.searchParams, ...value} //Merge two object
    },
    resetSearchParams(state){
      state.searchParams = {...state.searchParams, ...{
          makeIdProxy: null,
          modelIdProxy: null,
          bodyTypeEnumProxy: null,
          fuelEnumProxy: null,
          gearingEnumProxy: null,
          emissionClassEnumProxy: null,
          powerFromIntProxy: null,
          powerToIntProxy: null,
          firstRegistrationFromIntProxy: null,
          firstRegistrationToIntProxy: null,
          mileageFromIntProxy: null,
          mileageToIntProxy: null,
          priceFromIntProxy: null,
          priceToIntProxy: null,
          offerTypeEnumProxy: [],
          bodyColorEnumProxy: null,
          upholsteryEnumProxy: null,
          equipmentEnumProxy: [],
          pageIntProxy: 1}
      }
    },
    updateSelectedId(state, value){
      state.selectedId = value
    },
    updateResultsCount(state, value){
      state.resultsCountProxy = value
    },
    updateSiteUrl(state, value){
      state.siteUrl = value
    },
    updateCarOfTheWeek(state, value){
      state.carOfTheWeekId = value
    },
    updateVWPhonenumber(state, value){
      state.phoneLocationVW = value
    },
    updateSEATPhonenumber(state, value){
      state.phoneLocationSEAT = value
    },
    updateFCAPhonenumber(state, value){
      state.phoneLocationFCA = value
    },
    updateAutoCRMLeadnumber(state, value){
      state.phoneAutoCRMLead = value
    },
    updateMarketPath(state, value){
      state.marketPath = value
    },
    updateDetailsPath(state, value){
      state.detailsPath = value
    },
    onSortChange(state){
      state.searchParams.pageIntProxy = 1
      state.sortChanged = true
    },
    onResultsFinished(state){
      state.sortChanged = false
    }
  },
  actions: {

  }
})
